import {
  FETCH_LIQUIDACIONES_LISTA_SELLERS,
  FETCH_SELLERS_FILTER,
  FETCH_FACTURACIONES,
  FETCH_INTEGRADORES,
  SET_FILTRO_SELLER,
  FETCH_SELLERS,
  FETCH_SELLER,
  EDIT_SELLER,
  FETCH_PROVEEDORES_FILTER,
  LOADING_SELLERS,
  RESET_SELLERS,
  FETCH_PROVINCIAS_LOCALIDADES,
  CLEAR_LOCALIDAD_PROVINCIA,
  SET_LOGISTICA_PROPIA,
  SET_LOGISTICA_CACHE,
  SET_LOGISTICA_DIRTY,
  CLEAR_LOGISTICA_FOR_SELLER
} from './types';
import {
    getSeller,
    listSellersParameters,
    getIntegradores,
    getTipoFacturacion,
    getLiquidacionesListaSellers,
    fetchDesplegableProveedoresApi,
    getProvinciaLocalidadByCodigoPostalApi,
    fetchLogisticaPropiaApi,
    updateLogisticaPropiaApi,
    putEstadoSellerApi,
    postSellerApi,
    putSellerApi,
    getlistGestionDatosBancariosSellersTesoreriaApi,
    getSellerDesplegableApi
} from "../api/axios";
import { setIdIntegrador, setIdEstado, safeInt, setIdTipoFacturacion, encryptPassword, parseFieldValueForUpdate } from '../utilities';
import { toast } from '../utilities/appToast';

const toArray = (data) => {
  // Si por algún motivo llega como string, intentar parsear
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      data = (typeof parsed === 'string') ? JSON.parse(parsed) : parsed;
    } catch { }
  }
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.elementos)) return data.elementos;
  if (Array.isArray(data?.content)) return data.content;
  // Shape observado: { page, pageSize, total, content: [ { datosSellerDesplegables: [...] } ] }
  if (Array.isArray(data?.content?.[0]?.datosSellerDesplegables)) return data.content[0].datosSellerDesplegables;
  // Variante: { content: { datosSellerDesplegables: [...] } }
  if (Array.isArray(data?.content?.datosSellerDesplegables)) return data.content.datosSellerDesplegables;
  if (Array.isArray(data?.Content?.[0]?.DatosSellerDesplegables)) return data.Content[0].DatosSellerDesplegables;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.paginateSellers?.elementos)) return data.paginateSellers.elementos;
  if (Array.isArray(data?.paginateSellers?.content)) return data.paginateSellers.content;
  if (Array.isArray(data?.PaginateSellers?.Elementos)) return data.PaginateSellers.Elementos;
  if (Array.isArray(data?.PaginateSellers?.Content)) return data.PaginateSellers.Content;
  if (Array.isArray(data?.paginationResponseSellers?.content)) return data.paginationResponseSellers.content;
  if (Array.isArray(data?.PaginationResponseSellers?.Content)) return data.PaginationResponseSellers.Content;
  return [];
};

/** Total de páginas para la UI (react-paginate usa cantidadPagina). La API suele mandar totalPages y no cantidadPagina. */
const resolveTotalPages = (paginateBlock, itemsLength = 0) => {
  const ps = paginateBlock;
  if (!ps || typeof ps !== 'object') return itemsLength > 0 ? 1 : 0;
  const num = (x) => {
    if (x === undefined || x === null || x === '') return null;
    const v = Number(x);
    return Number.isFinite(v) ? v : null;
  };
  const explicit = num(
    ps.cantidadPagina ?? ps.CantidadPagina ?? ps.totalPages ?? ps.TotalPages
  );
  if (explicit != null && explicit >= 0) return explicit;

  const total = num(ps.cantidadTotal ?? ps.CantidadTotal ?? ps.total ?? ps.Total);
  const pageSize = num(ps.pageSize ?? ps.PageSize) || 10;
  if (total != null && total >= 0) {
    return Math.max(0, Math.ceil(total / pageSize));
  }

  return itemsLength > 0 ? 1 : 0;
};

const resolveSellerTotal = (response) => {
  const num = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  };
  const paginateSellers = response?.paginateSellers ?? response?.PaginateSellers;
  const paginationResponseSellers = response?.paginationResponseSellers ?? response?.PaginationResponseSellers;
  const total = num(
    paginateSellers?.cantidadTotal ?? paginateSellers?.CantidadTotal ?? paginateSellers?.total ?? paginateSellers?.Total ??
    paginationResponseSellers?.total ?? paginationResponseSellers?.Total ??
    response?.cantidadTotal ?? response?.CantidadTotal ?? response?.total ?? response?.Total
  );
  return total ?? toArray(response).length;
};

const normalizeSellerStatus = (estado) => String(estado ?? '').trim().toLowerCase();

const isActiveSellerStatus = (estado) => {
  const normalized = normalizeSellerStatus(estado);
  return normalized === 'activo' || normalized === 'activa' || normalized === '1';
};

const isInactiveSellerStatus = (estado) => {
  const normalized = normalizeSellerStatus(estado);
  return normalized === 'inactivo' || normalized === 'inactiva' || normalized === '2';
};

const normalizeSeller = (item) => ({
  ...item,
  codigo: item?.codigo ?? item?.Codigo ?? item?.idSeller ?? item?.IdSeller ?? 0,
  cuit: item?.cuit ?? item?.Cuit ?? "",
  telefono: item?.telefono ?? item?.Telefono ?? "",
  estado: normalizeSellerStatus(item?.estado ?? item?.Estado),
  domicilio: item?.domicilio ?? item?.Domicilio ?? "",
  email: item?.email ?? item?.Email ?? "",
  emailDespacho: item?.emailDespacho ?? item?.EmailDespacho ?? "",
  numeroDomicilio: item?.numeroDomicilio ?? item?.NumeroDomicilio ?? "",
  localidad: item?.localidad ?? item?.Localidad ?? "",
  provincia: item?.provincia ?? item?.Provincia ?? "",
  codigoPostal: item?.codigoPostal ?? item?.CodigoPostal ?? "",
  idSeller: item?.idSeller ?? item?.IdSeller ?? item?.codigo ?? item?.Codigo ?? 0,
  razonSocial: item?.razonSocial ?? item?.RazonSocial ?? item?.descripcion ?? item?.Descripcion ?? ""
});

const normalizeSellersPage = (response) => {
  const items = toArray(response).map(normalizeSeller);

  if (response?.paginateSellers || response?.PaginateSellers) {
    const paginateSellers = response?.paginateSellers ?? response?.PaginateSellers ?? {};
    const merged = {
      ...paginateSellers,
      elementos: items,
      cantidadPagina: resolveTotalPages(
        { ...paginateSellers, elementos: items },
        items.length
      )
    };
    return {
      ...response,
      paginateSellers: merged
    };
  }

  if (response?.paginationResponseSellers || response?.PaginationResponseSellers) {
    const pagination = response?.paginationResponseSellers ?? response?.PaginationResponseSellers ?? {};
    const block = {
      elementos: items,
      cantidadTotal: pagination?.total ?? pagination?.Total ?? items.length,
      cantidadPagina: pagination?.totalPages ?? pagination?.TotalPages,
      page: pagination?.page ?? pagination?.Page ?? 1,
      pageSize: pagination?.pageSize ?? pagination?.PageSize ?? items.length
    };
    return {
      ...response,
      paginateSellers: {
        ...block,
        cantidadPagina: resolveTotalPages(block, items.length)
      }
    };
  }

  const fallbackBlock = {
    elementos: items,
    cantidadTotal: response?.cantidadTotal ?? response?.CantidadTotal ?? items.length,
    cantidadPagina: response?.cantidadPagina ?? response?.CantidadPagina,
    page: response?.page ?? response?.Page ?? 1,
    pageSize: response?.pageSize ?? response?.PageSize
  };
  return {
    paginateSellers: {
      ...fallbackBlock,
      cantidadPagina: resolveTotalPages(fallbackBlock, items.length)
    }
  };
};

const extractApiErrorMessages = (error) => {
  const data = error?.response?.data;
  if (!data) return [];

  if (Array.isArray(data?.errores)) return data.errores.filter(Boolean);

  if (data?.errors && typeof data.errors === 'object') {
    return Object.values(data.errors)
      .flat()
      .filter(Boolean);
  }

  if (typeof data?.title === 'string' && data.title.trim()) return [data.title];
  return [];
};

export const fetchIntegradores = () => async dispatch => {
  getIntegradores().then(function (value) {
    dispatch({
      type: FETCH_INTEGRADORES,
      payload: value
    });
  });
}

export const fetchProveedoresFilter = (params) => async dispatch => {
  let options = [];
  const defaultParams = { Page: 1, PageSize: 10, ...params };
  let req = fetchDesplegableProveedoresApi(defaultParams);
  req.then((res) => {

    let data = [];
    // Handle new structure: { data: [{ codigo, descripcion }] }
    if (res && Array.isArray(res.data)) {
      data = res.data;
    }
    // Fallbacks for safety during transition/testing (optional, can be removed if strict)
    else if (res.paginationResponseProveedores && Array.isArray(res.paginationResponseProveedores.content)) {
      data = res.paginationResponseProveedores.content;
    } else if (res.elementos && Array.isArray(res.elementos)) {
      data = res.elementos;
    }

    if (data.length > 0) {
      options = data.map((proveedor) => {
        // Adapt to simpler structure (codigo, descripcion) or fallbacks
        const labelText = proveedor.descripcion || proveedor.Descripcion || proveedor.denomin || proveedor.Denomin || "";
        return {
          value: proveedor.codigo || proveedor.Codigo,
          label: labelText.trim()
        };
      });
    }

    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: options
    });
  }).catch((err) => {
    dispatch({
      type: FETCH_PROVEEDORES_FILTER,
      payload: []
    });
  });
}

export const setFiltroSeller = (filtro) => dispatch => {
  dispatch({
    type: SET_FILTRO_SELLER,
    payload: filtro
  });
}

export const fetchFacturaciones = () => async dispatch => {
  let array = getTipoFacturacion();
  let facturaciones;
  array.then(function (value) {

    facturaciones = value;
    dispatch({
      type: FETCH_FACTURACIONES,
      payload: facturaciones
    });
  });
}

export const fetchSellers = (Descripcion, CantidadPagina, NumeroPagina, IdEstado) => async dispatch => {
    dispatch({
        type: LOADING_SELLERS,
        payload: true
    });

    const sizePagina = Number.parseInt(CantidadPagina) ? Number.parseInt(CantidadPagina) : 10;
    const numeroPagina = Number.parseInt(NumeroPagina) ? Number.parseInt(NumeroPagina) : 1;
    const estadoSeller = IdEstado === null || IdEstado === undefined || IdEstado === '' ? '' : String(IdEstado);

    try {
      const currentPageResponse = await listSellersParameters(Descripcion, sizePagina, numeroPagina);
      const currentPage = normalizeSellersPage(currentPageResponse);
      const total = resolveSellerTotal(currentPageResponse);
      const currentItems = currentPage?.paginateSellers?.elementos ?? [];

      let allItems = currentItems;
      if (total > currentItems.length || estadoSeller !== '') {
        const allResponse = await listSellersParameters(Descripcion, Math.max(total, 1), 1);
        allItems = normalizeSellersPage(allResponse)?.paginateSellers?.elementos ?? [];
      }

      const sellerTotals = {
        total: total || allItems.length,
        activos: allItems.filter((item) => isActiveSellerStatus(item.estado)).length,
        inactivos: allItems.filter((item) => isInactiveSellerStatus(item.estado)).length
      };

      if (estadoSeller === '') {
        dispatch({
          type: FETCH_SELLERS,
          payload: { ...currentPage, sellerTotals }
        });
        return;
      }

      const filteredItems = allItems.filter((item) => (
        estadoSeller === '1'
          ? isActiveSellerStatus(item.estado)
          : isInactiveSellerStatus(item.estado)
      ));
      const start = (numeroPagina - 1) * sizePagina;
      const filteredPageCount = Math.ceil(filteredItems.length / sizePagina);
      const pageItems = filteredItems.slice(start, start + sizePagina);

      dispatch({
        type: FETCH_SELLERS,
        payload: {
          ...currentPage,
          sellerTotals,
          paginateSellers: {
            ...(currentPage?.paginateSellers ?? {}),
            elementos: pageItems,
            cantidadTotal: filteredItems.length,
            cantidadPagina: filteredPageCount,
            page: numeroPagina,
            pageSize: sizePagina
          }
        }
      });
    } catch {
      dispatch({
        type: FETCH_SELLERS,
        payload: {
          ...normalizeSellersPage({ paginateSellers: { elementos: [] } }),
          sellerTotals: { total: 0, activos: 0, inactivos: 0 }
        }
      });
    } finally {
      dispatch({
        type: LOADING_SELLERS,
        payload: false
      });
    }
}

export const fetchSellersFilter = (params) => async dispatch => {
    const defaultParams = { Descripcion: "", Page: 1, PageSize: 10, ...params };
    const descripcion = defaultParams.Descripcion ?? "";
    const pageSize = Number.parseInt(defaultParams.PageSize) ? defaultParams.PageSize : 10;
    const page = Number.parseInt(defaultParams.Page) ? defaultParams.Page : 1;

    try {
        // listSellersParameters utiliza el mismo endpoint que la gestión de sellers,
        // por eso obtiene coincidencias por cualquier parte del nombre.
        const res = await listSellersParameters(descripcion, pageSize, page);

        // Normalizar a lista utilizable (toArray maneja múltiples shapes de respuesta)
        const rawList = toArray(res);

        const mappedSellers = (rawList || [])
            .map(normalizeSeller)
            .map(seller => ({
                ...seller,
                value: seller.idSeller,
                label: seller.razonSocial
            }))
            .filter(s => s.value != null && String(s.value) !== "" && (s.label ?? "") !== "");

        dispatch({
            type: FETCH_SELLERS_FILTER,
            payload: mappedSellers
        });
    } catch {
        dispatch({
            type: FETCH_SELLERS_FILTER,
            payload: []
        });
    }
}

export const fetchSellersFilterLiquidaciones = (params) => async dispatch => {
  const defaultParams = { Descripcion: "", Page: 1, PageSize: 10, ...params };
  const descripcion = defaultParams.Descripcion ?? "";
  const pageSize = Number.parseInt(defaultParams.PageSize) ? defaultParams.PageSize : 10;
  const page = Number.parseInt(defaultParams.Page) ? defaultParams.Page : 1;

  try {
    const res = await listSellersParameters(descripcion, pageSize, page);
    const rawList = toArray(res);

    const mappedSellers = (rawList || [])
      .map(normalizeSeller)
      .map(seller => ({
        ...seller,
        value: seller.idSeller,
        label: seller.razonSocial
      }))
      .filter(s => s.value != null && String(s.value) !== "" && (s.label ?? "") !== "");

    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: mappedSellers
    });
  } catch {
    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: []
    });
  }
}

export const fetchSeller = (id) => async dispatch => {

  let seller;
  if (typeof id !== 'undefined') {

    let sellers = getSeller(id);
    sellers.then(function (value) {
      const normalized = normalizeSellersPage(value);
      seller = normalized?.paginateSellers?.elementos?.[0];

      if (!seller && value?.seller) seller = normalizeSeller(value.seller);
      if (!seller && value?.Seller) seller = normalizeSeller(value.Seller);
      if (!seller) seller = {};

      dispatch({
        type: FETCH_SELLER,
        payload: seller
      });
    }).catch((err) => {
      const errors = extractApiErrorMessages(err);

      if (errors.length > 0) {
        errors.forEach((msg) => toast.error(msg));
      } else {
        toast.error("No se pudo obtener la información del seller");
      }
    });
  } else {
    seller = {
      codigo: '',
      codigoPostal: '',
      cuit: '',
      domicilio: '',
      email: '',
      emailUsuario: '',
      emailDespacho: '',
      estado: '',
      idEstado: 1,
      integrador: 1,
      localidad: '',
      numeroDomicilio: '',
      provincia: '',
      razonSocial: '',
      telefono: '',
      tipoFacturacion: 1,
      urlPushOrdenes: '',
      sufijo: '',
      idEmpresaEnviopack: 0,
      nombreUsuario: '',
      nombreTienda: '',
      logo: '',
      tiendaActiva: false,
      internacional: false,
      emisionFacturaA: false,
    }

    dispatch({
      type: FETCH_SELLER,
      payload: seller
    });
  }
}

export const editSeller = (seller) => dispatch => {
  dispatch({
    type: EDIT_SELLER,
    payload: seller
  });
}

export const fetchLiquidacionesListaSellers = (force = false) => async (dispatch, getState) => {
  const cached = getState()?.sellers?.lista_sellers_liquidaciones;
  if (!force && Array.isArray(cached) && cached.length > 0) {
    return cached;
  }

  try {
    const value = await getLiquidacionesListaSellers();
    const lista = value?.listaSellersLiquidaciones ?? [];

    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: lista
    });

    return lista;
  } catch (error) {
    dispatch({
      type: FETCH_LIQUIDACIONES_LISTA_SELLERS,
      payload: []
    });
    throw error;
  }
}

export const resetSellers = () => async dispatch => {
  dispatch({
    type: RESET_SELLERS,
    payload: []
  })
};

export const updateListSellers = (sellersArray, seller) => async (dispatch) => {
  const elementos = sellersArray?.paginateSellers?.elementos;

  if (!Array.isArray(elementos) || elementos.length === 0) {
    // No hay elementos para actualizar, salir
    return;
  }

  const existe = elementos.some(item =>
    item.codigo === seller.codigo
  );

  if (!existe) {
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: [], // no hay cambios, no se actualiza
    });
    return;
  }

  const nuevosElementos = elementos.map(item =>
    item.codigo === seller.codigo ? seller : item
  );

  const updatedSellersArray = {
    ...sellersArray,
    paginateSellers: {
      ...sellersArray.paginateSellers,
      elementos: nuevosElementos,
    },
  };

  dispatch({
    type: 'UPDATE_SELLERS_LIST',
    payload: updatedSellersArray,
  });
};

export const changeSellerStatus = (seller, newStatus) => async (dispatch, getState) => {
  const { sellers } = getState().sellers;
  const originalState = structuredClone(sellers); // Forma moderna de hacer Json.parse(JSON.stringify())

  // Optimistic update
  const updatedSeller = { ...seller, estado: newStatus };
  dispatch(updateListSellers(sellers, updatedSeller));

  try {
    const userId = Number.parseInt(getState().general.userId, 10) || 0;
    const request = {
      idUsuario: userId,
      listRequest: [
        {
          idSeller: seller.codigo,
          idEstado: newStatus === "activo" ? 1 : 2
        }
      ]
    };
    await putEstadoSellerApi(request);
    const nombre = seller.razonSocial || seller.descripcion || "Seller";
    if (newStatus === "activo") {
      toast.success(`${nombre} quedó activo`);
    } else {
      toast.error(`${nombre} quedó inactivo`);
    }
  } catch (error) {
    // Revert on error
    dispatch({
      type: 'UPDATE_SELLERS_LIST',
      payload: originalState,
    });
    const errors = extractApiErrorMessages(error);
    if (errors.length > 0) {
      errors.forEach((msg) => toast.error(msg));
    } else {
      toast.error("No se pudo actualizar el estado del seller");
    }
    throw error;
  }
};

export const fetchProvinciaLocalidadByCodigoPostal = (data) => async (dispatch) => {

  try {
    const res = await getProvinciaLocalidadByCodigoPostalApi(data);

    dispatch({
      type: FETCH_PROVINCIAS_LOCALIDADES,
      payload: res.localidadProvincia
    });
  } catch (error) {
    console.error("Error al obtener provincias/localidades", error);
  }
};

export const clearLocalidadProvincia = () => ({
  type: CLEAR_LOCALIDAD_PROVINCIA
});


export const fetchLogisticaPropia = (idSeller, { force = false } = {}) =>
  async (dispatch, getState) => {
    const cached = getState().sellers.logisticaCache?.[idSeller];

    // ✅ si hay caché, úsala (aunque esté dirty). Evita “pegadas” al cambiar de tab.
    if (!force && cached?.data) {
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: cached.data });
      return cached.data;
    }

    // si no hay caché o pedís force, pegá
    const data = await fetchLogisticaPropiaApi(idSeller);
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: data });
    return data;
  };



export const updateLogisticaEscalaField =
  ({ idSeller, idEscala, zona, field, value }) =>
    (dispatch, getState) => {
      const lp = getState().sellers.logisticaPropia || { escalas: [] };

      const next = structuredClone(lp);
      const esc = next.escalas.find(e => e.idEscala === idEscala);
      if (!esc) return;

      const parsed = parseFieldValueForUpdate(field, value);

      esc[zona] = esc[zona] || {};
      esc[zona][field] = parsed;

      // Envío gratis fuerza costo a 0 (guardando el valor previo para restaurarlo al desactivar)
      if (field === 'envioGratis') {
        if (parsed) {
          esc[zona].costoPrevio = esc[zona].costo ?? null;
          esc[zona].costo = 0;
        } else if (esc[zona].costoPrevio !== undefined) {
          esc[zona].costo = esc[zona].costoPrevio;
          delete esc[zona].costoPrevio;
        }
      }

      // Actualiza la activa para render inmediato
      dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });

      // Marca dirty y guarda en caché bajo la clave CORRECTA (idSeller)
      if (idSeller != null) {
        dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
        dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
      }
    };
export const submitLogisticaPropia = ({ idSeller, zonas, bodyFromState }) =>
  async (dispatch) => {
    await updateLogisticaPropiaApi({ idSeller: Number(idSeller), zonas });

    // opcional: o bien forzar un GET fresco…
    // const data = await fetchLogisticaPropiaApi(idSeller);

    // …o confiar en lo que tenés en memoria (bodyFromState) y marcar clean:
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: bodyFromState, dirty: false } });
    dispatch({ type: SET_LOGISTICA_PROPIA, payload: bodyFromState });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: false } });
  };

export const clearLogisticaForSeller = (idSeller) => (dispatch) => {
  dispatch({ type: CLEAR_LOGISTICA_FOR_SELLER, payload: { idSeller } });
};


// helpers locales
const ZONES = ['amba', 'interior', 'patagonia'];
const clone = (o) => structuredClone(o);

/**
 * Inicializa lp.zonasUI a partir de escalas/envioGratisZona si aún no existe.
 * No pisa si ya existe.
 */
export const initZonasUI = (idSeller) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  // si ya existe, no hacemos nada
  if (lp.zonasUI) return;

  const escalas = lp.escalas || [];
  const envioGratisZona = lp.envioGratisZona || {};
  const zonasUI = {};

  ZONES.forEach((z) => {
    const enabled = escalas.some(e => e[z] !== null && typeof e[z] === 'object');
    const envioGratis = !!envioGratisZona[z];
    zonasUI[z] = { enabled, envioGratis };
  });

  const next = { ...lp, zonasUI };

  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: false } });
};

/**
 * Toggle/Set de switches: enabled / envioGratis
 * Reglas:
 *  - Si deshabilito enabled => envioGratis = false
 *  - No permito marcar envioGratis si enabled está false
 */
export const updateZonaToggle = ({ idSeller, zona, field, value }) => (dispatch, getState) => {
  const lp = getState().sellers.logisticaPropia;
  if (!lp) return;

  const next = clone(lp);
  next.zonasUI = next.zonasUI || {};
  const curr = next.zonasUI[zona] || { enabled: false, envioGratis: false };
  const updated = { ...curr };

  if (field === 'enabled') {
    updated.enabled = (value != null) ? !!value : !curr.enabled;
    if (!updated.enabled) updated.envioGratis = false;
  } else if (field === 'envioGratis') {
    if (!curr.enabled) return; // ignorar si no está habilitada
    updated.envioGratis = (value != null) ? !!value : !curr.envioGratis;
  }

  next.zonasUI[zona] = updated;

  // Envío gratis a nivel zona fuerza costo a 0 (y lo restaura al desactivar) en todas las escalas de esa zona
  if (field === 'envioGratis') {
    (next.escalas || []).forEach((esc) => {
      if (!esc[zona] || typeof esc[zona] !== 'object') return;

      if (updated.envioGratis) {
        esc[zona].costoPrevio = esc[zona].costo ?? null;
        esc[zona].costo = 0;
      } else if (esc[zona].costoPrevio !== undefined) {
        esc[zona].costo = esc[zona].costoPrevio;
        delete esc[zona].costoPrevio;
      }
    });
  }

  // actualizo activa + cache y marco dirty
  dispatch({ type: SET_LOGISTICA_PROPIA, payload: next });
  if (idSeller != null) {
    dispatch({ type: SET_LOGISTICA_CACHE, payload: { idSeller, data: next, dirty: true } });
    dispatch({ type: SET_LOGISTICA_DIRTY, payload: { idSeller, dirty: true } });
  }
};

export const postSeller = async (data) => {
    const idIntegrador = setIdIntegrador(data);
    const idTipoFacturacion = setIdTipoFacturacion(data);

    const modalidadEPK =
        data.modalidadEPK !== undefined && data.modalidadEPK !== null && data.modalidadEPK !== ""
            ? data.modalidadEPK
            : "s";

    const idEstado = setIdEstado(data);

    const trimStr = (v) => (v == null || v === undefined ? '' : String(v).trim());
    const cuitDigits = trimStr(data.cuit).replace(/\D/g, '');
    const idEmpresaPk = safeInt(data.idEmpresaEnviopack, 0);
    // 0 suele romper FK hacia Empresa Enviopack en Core; null = "sin empresa" si la columna es nullable.
    const idEmpresaEnvioPack = idEmpresaPk > 0 ? idEmpresaPk : null;

    const seller = {
        "idIntegrador": idIntegrador,
        "sufijo": trimStr(data.sufijo),
        "idEstado": idEstado,
        "idTipoFacturacion": idTipoFacturacion,
        "razonSocial": trimStr(data.razonSocial),
        "domicilio": trimStr(data.domicilio),
        "numeroDomicilio": safeInt(data.numeroDomicilio, 0),
        "localidad": trimStr(data.localidad),
        "provincia": trimStr(data.provincia),
        "codigoPostal": safeInt(data.codigoPostal, 0),
        "telefono": trimStr(data.telefono),
        "cuit": cuitDigits,
        "email": trimStr(data.email),
        "emailDespacho": (() => {
            const d = trimStr(data.emailDespacho);
            const m = trimStr(data.email);
            return d !== '' ? d : m;
        })(),
        "emailUsuario": trimStr(data.emailUsuario),
        "urlPushOrdenes": data.urlPushOrdenes != null && trimStr(data.urlPushOrdenes) !== '' ? trimStr(data.urlPushOrdenes) : "",
        "idEmpresaEnvioPack": idEmpresaEnvioPack,
        "modalidadEPK": modalidadEPK,
        "diasCorte": data.diasCorte != null && data.diasCorte !== "" ? safeInt(data.diasCorte, 0) : 0,
        "diasPlazoPago": data.diasPlazoPago != null && data.diasPlazoPago !== "" ? safeInt(data.diasPlazoPago, 0) : 0,
        "nombreTienda": trimStr(data.nombreTienda),
        "logo": data.logo != null && trimStr(data.logo) !== '' ? trimStr(data.logo) : "",
        "tiendaActiva": !!data.tiendaActiva,
        "nombreUsuario": trimStr(data.nombreUsuario),
        "usuario": trimStr(data.nombreUsuario),
        "password": encryptPassword(data.password),
        "envioPropio": data.envioPropio !== undefined ? data.envioPropio : false,
        "internacional": !!data.internacional,
        "etiquetaSellerResumen": (() => {
            const t = data.etiquetaSellerResumen != null ? trimStr(data.etiquetaSellerResumen) : '';
            return t !== '' ? t : null;
        })(),
        "promesaEntrega": safeInt(data.promesaEntrega, 0)
    };

    try {
        const response = await postSellerApi(seller);
        return response;
    } catch (error) {
      throw error;
    }
}

export const putSeller = async (data) => {
    // API (SellersCore/EditarSeller): PromesaEntrega es int?; "" o string no numérica rompe la deserialización
    // y deja el body sin bindear ("The request field is required").
    const promesaEntregaApi = (() => {
        const v = data.promesaEntrega;
        if (v == null || v === "") return null;
        if (typeof v === "number" && Number.isFinite(v)) return v;
        const n = parseInt(String(v).trim(), 10);
        return Number.isFinite(n) ? n : null;
    })();

    const idIntegrador = setIdIntegrador(data);
    const idTipoFacturacion = setIdTipoFacturacion(data);

    let seller = {
        "idUsuario": Number.parseInt(data.idUsuario ?? data.userId, 10) || 0,
        "idSeller": data.codigo,
        "idIntegrador": idIntegrador,
        "razonSocial": data.razonSocial,
        "domicilio": data.domicilio,
        "numeroDomicilio": safeInt(data.numeroDomicilio, 0),
        "localidad": data.localidad,
        "provincia": data.provincia,
        "codigoPostal": safeInt(data.codigoPostal, 0),
        "telefono": data.telefono,
        "cuit": data.cuit,
        "email": data.email,
        "emailDespacho": data.emailDespacho,
        "emailUsuario": data.emailUsuario,
        "nombreUsuario": data.nombreUsuario,
        "urlPushOrdenes": data.urlPushOrdenes,
        "sufijo": data.sufijo,
        "idTipoFacturacion": idTipoFacturacion,
        "idEmpresaEnviopack": safeInt(data.idEmpresaEnviopack, 0),
        "modalidadEPK": data.modalidadEPK !== "" ? data.modalidadEPK : "e",
        "diasCorte": data.diasCorte != "" ? safeInt(data.diasCorte, 0) : 0,
        "diasPlazoPago": data.diasPlazoPago != "" ? safeInt(data.diasPlazoPago, 0) : 0,
        "nombreTienda": data.nombreTienda,
        "logo": data.logo,
        "tiendaActiva": data.tiendaActiva,
        "envioPropio": data.envioPropio,
        "internacional": data.internacional,
        "slugTienda": data.slugTienda,
        "emisionFacturaA": data.emisionFacturaA,
        "etiquetaSellerResumen": data.etiquetaSellerResumen,
        "promesaEntrega": promesaEntregaApi
    }

    try {
        const response = await putSellerApi(seller);
        return response;
    } catch (error) {
      throw error;
    }
}

export const getlistGestionDatosBancariosSellersTesoreria = async (request) => {
    const estado = request?.estado;
    const page = request?.page;
    const pageSize = request?.pageSize;
    let params = {};

    const estadoNum = estado === null || estado === undefined ? null : Number(estado);
    if (estadoNum !== null && !Number.isNaN(estadoNum)) {
        params.estado = estadoNum;
    }
    if (page !== null && page !== undefined) params.Page = page;
    if (pageSize !== null && pageSize !== undefined) params.PageSize = pageSize;

    params = Object.keys(params).length > 0 ? params : undefined;

    try {
        const response = await getlistGestionDatosBancariosSellersTesoreriaApi(params);
        return response;
    } catch { }
}

export const getSellerDesplegable = async (params) => {
    const p = params ?? {};
    // Normalizar nombres de query params para el backend externo (suele esperar camel/lowercase)
    const normalizedParams = {
        ...p,
        ...(p.Descripcion != null && p.descripcion == null ? { descripcion: p.Descripcion } : null),
        ...(p.Page != null && p.page == null ? { page: p.Page } : null),
        ...(p.PageSize != null && p.pageSize == null ? { pageSize: p.PageSize } : null),
    };
    const token = (typeof window !== "undefined" && window.localStorage)
        ? window.localStorage.getItem("token")
        : null;

    try {
        let data = await getSellerDesplegableApi(normalizedParams, token)

        // A veces el proxy devuelve JSON como string (por Content-Type no json)
        if (typeof data === 'string') {
            // soportar doble-serialización (string JSON dentro de string)
            const first = JSON.parse(data);
            data = (typeof first === 'string') ? JSON.parse(first) : first;
        }

        return data;
    } catch { }
}
